<template>
    <div id="strategy-page">
        <LandingBanner />
        <ExtraInfo />
        <DirectFinance />
        <FirstStrategy />
        <SecondStrategy />
        <ThirdStrategy />
        <FourthStrategy />
    </div>
</template>
    
<script>
import sal from 'sal.js';
import LandingBanner from '@components/landing-components/strategy-components/LandingBanner.vue';
import ExtraInfo from '@components/landing-components/strategy-components/ExtraInfo.vue';
import DirectFinance from '@components/landing-components/strategy-components/DirectFinance.vue';
import FirstStrategy from '@components/landing-components/strategy-components/FirstStrategy.vue';
import SecondStrategy from '@components/landing-components/strategy-components/SecondStrategy.vue';
import ThirdStrategy from '../../components/landing-components/strategy-components/ThirdStrategy.vue';
import FourthStrategy from '../../components/landing-components/strategy-components/FourthStrategy.vue';
export default {
    name: "StrategyPage",
    components: {
    LandingBanner,
    ExtraInfo,
    DirectFinance,
    FirstStrategy,
    SecondStrategy,
    ThirdStrategy,
    FourthStrategy
},
    mounted() {
        sal();
    },
    data() {
        return {

        }
    }
}
</script>
    
<style scoped>

</style>